import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import FirebaseEmailVerificationCheck from "../../../../shared/components/Firebase/FirebaseEmailVerificationCheck";
import LoadingSpinner from "../../../../shared/components/LoadingSpinner";
import { setAuthenticatedUser } from "../../../../shared/actions";
import { setPage } from "../../actions";
import P from "../../pages";
import { useFeature } from "../../../../shared/components/FeatureContext";
import FirebaseCreateAccountForm from "./FirebaseCreateAccountForm";

const FirebaseRegisterForm = ({ intl }) => {
  const dispatch = useDispatch()
  const authenticatedUser = useSelector(state => state.authenticatedUser)
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const oobCode = urlParams.get("oobCode");
  const [emailVerified, setEmailVerified] = useState(oobCode ? false : null)
  const [checkingToken, setCheckingToken] = useState(false)
  const emailVerificationStandalone = useFeature("email_verification_standalone");

  const onEmailVerified = () => {
    dispatch(setPage(P.FIREBASE_DETAILS_PAGE))
  }

  useEffect(() => {
    if (Object.keys(authenticatedUser).length > 0) return
    const signInWithToken = async () => {
      setCheckingToken(true)
      try {
        const resp = await fetch("/users/sign_in_with_token", {
          method: "post",
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]").getAttribute("content")
          },
          body: JSON.stringify({ token })
        })
        const data = await resp.json()
        if (data.success && data.authenticated_user) {
          dispatch(setAuthenticatedUser(data.authenticated_user))
          if (data.authenticated_user.email_verified) {
            dispatch(setPage(P.FIREBASE_DETAILS_PAGE))
          } else {
            setCheckingToken(false)
            setEmailVerified(false)
          }
        } else {
          setCheckingToken(false)
        }
      } catch (err) {
        console.error("Token login failed", err)
        setCheckingToken(false)
      }
    }

    const hydrateFromServer = async () => {
      const meResp = await fetch("/authenticated_users/me", {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]").getAttribute("content")
        }
      })

      if (!meResp.ok) {
        setCheckingToken(false)
        return
      }

      const meData = await meResp.json()
      if (meData.success && meData.authenticated_user) {
        dispatch(setAuthenticatedUser(meData.authenticated_user))
        if (meData.authenticated_user.email_verified) {
          dispatch(setPage(P.FIREBASE_DETAILS_PAGE))
        } else {
          setCheckingToken(false)
          setEmailVerified(false)
        }
      } else {
        setCheckingToken(false)
      }
    }

    if (token && !emailVerificationStandalone) {
      signInWithToken()
    } else {
      hydrateFromServer()
    }
  }, [])

  useEffect(() => {
    if (Object.keys(authenticatedUser).length == 0) return

    if (authenticatedUser.email_verified) {
      dispatch(setPage(P.FIREBASE_DETAILS_PAGE))
    } else {
      setCheckingToken(false)
      setEmailVerified(false)
    }
  }, [authenticatedUser])

  if (checkingToken) return <LoadingSpinner />

  return (
    emailVerified !== false ? (
        <FirebaseCreateAccountForm intl={intl} setEmailVerified={setEmailVerified} />
    ) : (
        <FirebaseEmailVerificationCheck intl={intl} subject="host" onEmailVerified={onEmailVerified} />
    )
  );
}

FirebaseRegisterForm.propTypes = {
  intl: PropTypes.object
};

export default injectIntl(FirebaseRegisterForm);
